import { TrackingPayload } from "./tracking-payload.interface";

export class FindLocationPayload implements TrackingPayload {
    constructor(
        public zip: string,
        public street: string
    ) { }

    public toMetaFormat(): Record<string, any> {
        return {
            zip: this.zip,
            street: this.street,
        };
    }
}